import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import { AppDispatch } from "../../../app/store";
import { api } from "../../../config/settings";
import setQueryFilters from "../../utils/setQueryFilters";
import {
  AdditionalPaginationState,
  EntityActionReducerBuilderInterface,
  PaginationResponse,
  FulfilledUpdateMethod,
  FULFILLED_UPDATE_METHOD,
  REQUEST_STATE,
} from "../../dataTypes";
import { createAsyncThunk } from "../../utils/createAsyncThunk";
import defaultRestOptions from "../../utils/defaultRestOptions";
import {
  ResponseWebOrderContent,
  WebOrderContent,
  WebOrderContentsFilter,
  webOrderContentSliceName,
} from "../dataTypes";
import { webOrderContentAdapter } from "../webOrderContentAdapter";

async function getWebOrderContents(dispatch: AppDispatch, filters?: WebOrderContentsFilter) {
  const url = api.webOrderContent.webOrderContents();

  setQueryFilters(url, filters);

  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions({ dispatch }));
}

export const fetchWebOrderContents = createAsyncThunk<
  PaginationResponse<ResponseWebOrderContent>,
  { filter?: WebOrderContentsFilter; fulfilledUpdateMethod?: FulfilledUpdateMethod }
>(webOrderContentSliceName + "/fetchWebOrderContents", (dispatch, { filter }) => getWebOrderContents(dispatch, filter));

export const addFetchWebOrderContentsReducers = (
  builder: EntityActionReducerBuilderInterface<WebOrderContent, AdditionalPaginationState>,
) => {
  builder.addCase(fetchWebOrderContents.pending, state => {
    state.requestState = REQUEST_STATE.PENDING;
    state.errorMessage = undefined;
  });
  builder.addCase(fetchWebOrderContents.fulfilled, (state, action) => {
    const {
      payload,
      meta: {
        arg: { fulfilledUpdateMethod = FULFILLED_UPDATE_METHOD.UPSERT_MANY },
      },
    } = action;

    const mapResponse = (responseObject: ResponseWebOrderContent): WebOrderContent => ({
      ...responseObject,
      fetchedTimestamp: Date.now(),
      requestState: REQUEST_STATE.FULFILLED,
      errorMessage: undefined,
    });

    switch (fulfilledUpdateMethod) {
      case FULFILLED_UPDATE_METHOD.SET_ALL:
        webOrderContentAdapter.setAll(state, payload.page.map(mapResponse));
        break;
      case FULFILLED_UPDATE_METHOD.UPSERT_MANY:
        webOrderContentAdapter.upsertMany(state, payload.page.map(mapResponse));
        break;
    }

    state.count = payload.count;
    state.requestState = REQUEST_STATE.FULFILLED;
  });
  builder.addCase(fetchWebOrderContents.rejected, (state, action) => {
    state.requestState = REQUEST_STATE.REJECTED;
    state.errorMessage = action.payload?.message;
  });
};
